import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'
import Foreclosuresheader from '../components/Servicelist5/Foreclosuresheader'
import Foreclosuresdetails from '../components/Servicelist5/Foreclosuresdetails'

const Foreclosuresheaderpage = () => {
    return (
        <div>
        <Navbar/>
        <Foreclosuresheader/>
        <Foreclosuresdetails/>



        <Footer/>

        </div>
    )
}

export default Foreclosuresheaderpage